export default __webpack_public_path__ + "static/media/default-auto-listing-preview.534ba81d.jpg";